import React from 'react';
import CSS from './styles.scss';

const PageSelectorViews = props => {
  const isPlaceholder = !props.inputValue
  let inputBox;
  if (props.pageBreakError) {
    inputBox = CSS['page__input--error']
  } else if (isPlaceholder) {
    inputBox = CSS['page__input_placeholder'];
  } else {
    inputBox = CSS['page__input'];
  }
  const arrowStyle = props.isMobile ? CSS['arrow-up'] : CSS['arrow-left'];
  const errorTextStyle = props.isMobile ? CSS['tooltiptext-up'] : CSS['tooltiptext'];
  return (
    <div className={CSS['tooltip']}>
      <input
        onKeyDown={ props.goToPage }
        onFocus={ props.handleInputFocus }
        onBlur={ props.handleInputBlur }
        value={ props.inputValue }
        className={ inputBox }
        onChange={ props.handlePageInputChange }
        htmlFor="pageNumberInput"
        aria-labelledby="pageNumberLabel"
        data-test-id="page-number-input"
      />
      <div id="pageNumberLabel" aria-live="polite">
        {
          !props.pageBreakError
              ? <span className={CSS['screenReaderOnly']}>Page number input</span>
              : <>
                  <div
                    className={arrowStyle}
                  />
                  <span
                    id="pageNumberErrorMessage"
                    className={errorTextStyle}
                    aria-label={props.pageBreakError}
                  >
                  {props.pageBreakError}
                  </span>
                </>
        }
      </div>
    </div>
  );
}

export default PageSelectorViews;
